import React, { useEffect, useContext, useState, useRef } from "react";
import { DocumentDetailContext } from "pages/DocumentDetail/contexts/DocumentDetailContext";
import { Edit } from "@mui/icons-material";
import { TextField } from "@mui/material";


const FlagNotes = (props) => {
    const { setDocumentData, data = {}, duplicateDocumentView, setDialogs, setDataSave, isDarkMode } = useContext(DocumentDetailContext);
    const [showTextBox, setShowTextBox] = useState(false);
    const [inputText, setInputText] = useState(data?.Entity_Details?.notes || "");
    const flagNotesRef = useRef(null);

    useEffect(() => {
        let temp = { ...data };
        temp.Entity_Details.notes = inputText;
        setDocumentData({ ...temp });
    }, [inputText]);

    useEffect(() => {
        setInputText(data?.Entity_Details?.notes || "");
    }, [data?.Entity_Details?.notes]);

    useEffect(() => {
        function handleOutsideClick(event) {
            if (flagNotesRef.current && !flagNotesRef.current.contains(event.target)) {
                setShowTextBox(false)
            }
        }
        document.addEventListener("click", handleOutsideClick);
        return () => document.removeEventListener("click", handleOutsideClick);
    }, []);

    const isSpamSelected = () => {
        const { Tags = [] } = data || {};
        let flag = false;
        Tags.forEach(m => {
            if (m.tag_display_name == "SPAM" && m.enabled) {
                flag = true;
            }
        });
        return flag;
    }

    const handleChange = (e) => {
        const value = e.target.value;
        if(isSpamSelected() && value?.endsWith("\n")) return null;
        setInputText(e.target.value);
        setDataSave(true);
    }

    const validateFlagNotes = (e) => {
        const value = e.target.value;
        if (isSpamSelected() && value?.trim() && !(value?.match(/^(\+\d{1,2}\s)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/i))) {
            setDialogs(prevState => ({
                ...prevState,
                spamFaxNumberValidation: true
            }));
            setInputText("");
        }
    }

    return <div className="notes-section" ref={flagNotesRef}>
        <div className="icon-text" style={{ width: "max-content", cursor: !duplicateDocumentView ? "pointer" : "auto" }}>
            <div className="notes-label">Flag Notes</div>
            {<Edit
                fontSize="small"
                className={!duplicateDocumentView ? "icon-review-style" : "icon-remove-style"}
                onClick={() => {
                    if (!duplicateDocumentView) {
                        setShowTextBox(true);
                    }

                }} />}
        </div>
        {showTextBox ?
            <TextField
                name="free_text"
                value={inputText}
                onChange={handleChange}
                id="outlined-textarea"
                rows={2}
                multiline
                onBlur={validateFlagNotes}
                sx={{
                    width: 200,
                    "> div": {
                        padding: "5px 10px"
                    },
                    "> div": {
                        padding: "5px 10px",
                        color: "var(--text-primary)"
                    },
                    '& .MuiOutlinedInput-root': {
                        '& fieldset': {
                            border: "1px solid var(--border-dark)"
                        },
                        '&:hover fieldset': {
                            border: isDarkMode ? "1px solid var(--border-dark)" : '1px solid var(--hti-purple-70)',
                            boxShadow: "0 4px 4px #0000000d"
                        },
                        '&.Mui-focused fieldset': {
                            border: isDarkMode ? "1px solid var(--border-dark)" : '1px solid var(--hti-purple-70) !important',
                        },
                    },
                }}
            />
            :
            <div style={{ textAlign: "left" }}>{data.Entity_Details?.notes}</div>}
    </div>
}

export default FlagNotes;